import { BRAND } from "@/lib/brand";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-black border-t border-yellow-500/30 px-6 md:px-12 pt-16 pb-8"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <img src={BRAND.logo} alt="LAD Performance" className="h-14 w-14 object-contain" />
              <div className="leading-none">
                <div className="font-display text-2xl text-white tracking-wide">LAD PERFORMANCE</div>
                <div className="text-[10px] uppercase tracking-[0.25em] text-yellow-500 mt-1">
                  Préparation · E85
                </div>
              </div>
            </div>
            <p className="text-zinc-400 text-sm leading-relaxed max-w-sm">
              Spécialiste cartographie moteur, cartographie éthanol E85 et préparation
              automobile à Saint-André dans les Pyrénées-Orientales.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-display text-lg text-white tracking-wide mb-4">CONTACT</div>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li>{BRAND.address}</li>
              <li>
                <a href={`tel:${BRAND.phoneRaw}`} className="hover:text-yellow-500">
                  {BRAND.phone}
                </a>
              </li>
              <li className="break-all">
                <a href={`mailto:${BRAND.email}`} className="hover:text-yellow-500">
                  {BRAND.email}
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-display text-lg text-white tracking-wide mb-4">HORAIRES</div>
            <ul className="space-y-2 text-sm">
              {BRAND.hours.map((h) => (
                <li key={h.day} className="flex justify-between gap-4">
                  <span className="text-zinc-400">{h.day}</span>
                  <span className="text-white">{h.time}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div className="text-xs text-zinc-500 tracking-wide">
            © {new Date().getFullYear()} LAD Performance. Tous droits réservés.
          </div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-600">
            Saint-André · 66690 · Pyrénées-Orientales
          </div>
        </div>
      </div>
    </footer>
  );
};
